import React from 'react';

import Header from '../../main/components/Header';
import Path from '../../path/ui/Path';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import { t } from 'i18next';

import NewDetialInfo from '../components/NewDetialInfo';

const Main = () => {
    return (
        <div className="main_container">
            <Header />
            <Path currentPath={t('news')} />
            <NewDetialInfo />
            <div className="announcement_content">
                <MobileBottomBar />
            </div>
        </div>
    );
};

export default Main;